export const ROLEID = {
  ADMIN: 1,
  MANAGER: 2,
  USER: 3,
  TEAM_LEADER: 4,
};
export const primaryChemistMenu = {
  settings: {
    id: "settings",
    text: "Settings",
    path: "/settings",
    icon: "Settings",
    permission: [ROLEID.ADMIN],
    subMenu: {
      territory: {
        id: "territory",
        text: "Territory",
        path: "/settings/territory",
        icon: "GraphicEq",
        subMenu: null,
        permission: [ROLEID.ADMIN],
      },
      donationCategory: {
        id: "donation_category",
        text: "Donation Categories",
        path: "/settings/donation-category",
        icon: "CardGiftcard",
        permission: [ROLEID.ADMIN],
      },
      pharmacies: {
        id: "pharmacies",
        text: "Pharmacies",
        path: "/settings/pharmacies",
        icon: "Medication",
        permission: [ROLEID.ADMIN],
      },
      manageProducts: {
        id: "manage_product",
        text: "Manage Products",
        path: "/settings/manage_products",
        icon: "AppRegistration",
        subMenu: null,
        permission: [ROLEID.ADMIN],
      },
      warehouses: {
        id: "warehouses",
        text: "Ware Houses",
        path: "/settings/warehouses",
        icon: "MapsHomeWork",
        permission: [ROLEID.ADMIN],
      },
      users: {
        id: "userManagement",
        text: "Users",
        path: "/settings/users",
        icon: "Group",
        permission: [ROLEID.ADMIN],
      },
      product: {
        id: "product",
        text: "Products",
        path: "/settings/products",
        icon: "CardGiftcard",
        subMenu: null,
        permission: [ROLEID.ADMIN],
      },
      product_grouping: {
        id: "productGroup",
        text: "Product Grouping",
        path: "/settings/product-grouping",
        icon: "CardGiftcard",
        subMenu: null,
        permission: [ROLEID.ADMIN],
      },
      doctors: {
        id: "doctor",
        text: "Doctors",
        path: "/settings/doctors",
        icon: "GroupAdd",
        permission: [ROLEID.ADMIN],
      },
      noticeBoard: {
        id: "noticeboard",
        text: "Notice Board",
        path: "/settings/notice-board",
        icon: "FeaturedPlayList",
        permission: [ROLEID.ADMIN],
      },
      notification: {
        id: "notification",
        text: "Notification",
        path: "settings/notification",
        icon: "NotificationsActive",
        permission: [ROLEID.ADMIN, ROLEID.MANAGER],
      },
    },
  },
};

export const chemistMenuGroupOverview = {
  chemistMenuGroupOverview: {
    id: "Overview",
    text: "Overview",
    permission: [ROLEID.ADMIN, ROLEID.MANAGER, ROLEID.TEAM_LEADER],
  },
  dashboard: {
    id: "dashboard",
    text: "Dashboard",
    path: "/",
    icon: "Dashboard",
    subMenu: null,
    permission: [ROLEID.ADMIN, ROLEID.MANAGER, ROLEID.TEAM_LEADER],
  },
  // test: {
  // 	id: 'test',
  // 	text: 'Test',
  // 	path: '/test',
  // 	icon: 'Dashboard',
  // 	subMenu: null,
  // 	permission:[ROLEID.ADMIN,ROLEID.MANAGER]
  // },
  data: {
    id: "data",
    text: "Data",
    path: "/data",
    icon: "Leaderboard",
    permission: [ROLEID.ADMIN, ROLEID.MANAGER, ROLEID.TEAM_LEADER],
    subMenu: {
      target_and_achievement: {
        id: "target_and_achievement",
        text: "Target & Achievement",
        path: "data/target-and-achievement",
        icon: "TrackChanges",
        permission: [ROLEID.ADMIN],
      },
      depot_Revenue_collection: {
        id: "depot_Revenue_collection",
        text: "Depot Revenue Collection",
        path: "data/depot-revenue-collection",
        icon: "CollectionsBookmark",
        permission: [ROLEID.ADMIN],
      },
      sales: {
        id: "sales",
        text: "Sales",
        path: "data/sales",
        icon: "Loyalty",
        permission: [ROLEID.ADMIN],
      },
      prescriptions: {
        id: "prescriptions",
        text: "Prescriptions",
        path: "data/prescriptions",
        icon: "Article",
        permission: [ROLEID.ADMIN, ROLEID.MANAGER, ROLEID.TEAM_LEADER],
      },
      doctor_visit: {
        id: "doctorVisit",
        text: "Visit Data",
        path: "data/doctor-visit",
        icon: "MedicalServices",
        permission: [ROLEID.ADMIN, ROLEID.MANAGER, ROLEID.TEAM_LEADER],
      },
      entity: {
        id: "entity",
        text: "Entity",
        path: "data/entity",
        icon: "PermIdentity",
        permission: [ROLEID.ADMIN, ROLEID.MANAGER, ROLEID.TEAM_LEADER],
      },
      donationRecord: {
        id: "donationRecord",
        text: "Donation Records",
        path: "data/donation-record",
        icon: "CardGiftcard",
        permission: [ROLEID.ADMIN],
      },
      reportingData: {
        id: "reportingdata",
        text: "Reporting Data",
        path: "data/reporting-data",
        icon: "PermIdentity",
        permission: [ROLEID.ADMIN, ROLEID.TEAM_LEADER, ROLEID.MANAGER],
      },
      liveData: {
        id: "liveTV",
        text: "Live TV",
        path: "/live_tv",
        icon: "LiveTv",
        permission: [ROLEID.ADMIN],
      },
    },
  },
  reporting: {
    id: "reporting",
    text: "Reporting",
    path: "/reporting",
    icon: "Summarize",
    permission: [ROLEID.ADMIN, ROLEID.MANAGER, ROLEID.TEAM_LEADER],
    subMenu: {
      product_wise_prescription: {
        id: "product_wise_prescription",
        text: "Product wise Prescription",
        path: "reporting/product_wise_prescription",
        icon: "TrackChanges",
        permission: [ROLEID.ADMIN],
      },
      product_and_depot_wise_prescription_report: {
        id: "product_and_depot_wise_prescription_report",
        text: "Product and Depot Wise Prescription",
        path: "reporting/product_and_depot_wise_prescription_report",
        icon: "CollectionsBookmark",
        permission: [ROLEID.ADMIN],
      },
      top_products: {
        id: "top_products",
        text: "Top Products",
        path: "reporting/top_products",
        icon: "Medication",
        permission: [ROLEID.ADMIN, ROLEID.MANAGER, ROLEID.TEAM_LEADER],
      },
      top_prescription: {
        id: "top_prescription",
        text: "Top Prescription",
        path: "reporting/top_prescription",
        icon: "InsertDriveFile",
        permission: [ROLEID.ADMIN, ROLEID.MANAGER, ROLEID.TEAM_LEADER],
      },
      top_visit: {
        id: "top_visit",
        text: "Top Visit",
        path: "reporting/top_visit",
        icon: "MedicalServices",
        permission: [ROLEID.ADMIN, ROLEID.MANAGER, ROLEID.TEAM_LEADER],
      },
      overall_visit_report: {
        id: "overall_visit_report",
        text: "Overall Visit Report",
        path: "reporting/overall-visit-report",
        icon: "InsertDriveFile",
        permission: [ROLEID.ADMIN],
      },
      activeUsers: {
        id: "active_users",
        text: "Active Users",
        path: "reporting/active-users",
        icon: "Group",
        permission: [ROLEID.ADMIN],
      },
      overall_mrd_report: {
        id: "overall_mrd_report",
        text: "Overall MRD Report",
        path: "reporting/overall-mrd-report",
        icon: "InsertDriveFile",
        permission: [ROLEID.ADMIN],
      },
      attendence_report: {
        id: "attendence_report",
        text: "Attendence Report",
        path: "reporting/attendence_report",
        icon: "InsertDriveFile",
        permission: [ROLEID.ADMIN],
      },
      team_leader_overview: {
        id: "team_leader_overview",
        text: "Team Leader Overview",
        path: "reporting/team_leader_overview",
        icon: "SupervisedUserCircle",
        permission: [ROLEID.TEAM_LEADER],
      },
    },
  },
};

export const chemistMenuGroupManagement = {
  chemistMenuGroupManagement: {
    id: "chemistMenuGroupManagement",
    text: "Management",
    permission: [ROLEID.ADMIN],
  },
  targets: {
    id: "targets",
    text: "Targets",
    path: "/targets",
    icon: "Adjust",
    permission: [ROLEID.ADMIN],
    subMenu: {
      target: {
        id: "target",
        text: "General Target",
        path: "/targets",
        icon: "TrackChanges",
        permission: [ROLEID.ADMIN],
      },
      achieved_target: {
        id: "achieved_target",
        text: "Achieved Target",
        path: "/achieved-targets",
        icon: "PushPin",
        permission: [ROLEID.ADMIN],
      },
      product_target: {
        id: "product_target",
        text: "Product Target",
        path: "/product-target",
        icon: "ProductionQuantityLimits",
        permission: [ROLEID.ADMIN],
      },
      achieved_product_target: {
        id: "achieved_product_target",
        text: "Achieved Product Target",
        path: "/targets/product/achieved",
        icon: "PushPin",
        permission: [ROLEID.ADMIN],
      },
    },
  },
  donation_module: {
    id: "donation_module",
    text: "Donation",
    path: "/donation",
    icon: "VolunteerActivism",
    permission: [ROLEID.ADMIN],
    subMenu: {
      donation: {
        id: "donation",
        text: "Donation",
        path: "/donation",
        icon: "VolunteerActivism",
        permission: [ROLEID.ADMIN],
      },
    },
  },
  tour: {
    id: "tour",
    text: "Tour",
    path: "/tour",
    icon: "DirectionsBusFilled",
    subMenu: {
      tour_plan: {
        id: "tour-plan",
        text: "Tour Plan",
        path: "/tour/tour-plan",
        icon: "DirectionsBusFilled",
        permission: [ROLEID.ADMIN],
      },
      tour_detail: {
        id: "tour-detail",
        text: "Tour Detail",
        path: "/tour-detail",
        icon: "ListAlt",
        permission: [ROLEID.ADMIN],
      },
    },
    permission: [ROLEID.ADMIN],
  },
};

export const chemistMenuGroupLogistics = {
  chemistMenuGroupLogistics: {
    id: "chemistMenuGroupLogistics",
    text: "Logistics",
    permission: [ROLEID.ADMIN],
  },
  requisitions: {
    id: "requisitions",
    text: "Requisitions",
    path: "/requisitions",
    icon: "Assignment",
    subMenu: null,
    permission: [ROLEID.ADMIN],
  },
};

export const layoutPages = {
  login: {
    id: "login",
    text: "Login",
    path: "auth-pages/login",
    icon: "Login",
  },
  live_tv: {
    id: "LiveTV",
    text: "LiveTV",
    path: "/live_tv",
    icon: "LiveTv",
  },
  signUp: {
    id: "signUp",
    text: "Sign Up",
    path: "auth-pages/sign-up",
    icon: "PersonAdd",
  },

  page404: {
    id: "Page404",
    text: "404 Page",
    path: "auth-pages/404",
    icon: "ReportGmailerrorred",
  },
  headerAndSubheader: {
    id: "headerAndSubheader",
    text: "Header & Subheader",
    path: "page-layouts/header-and-subheader",
    icon: "ViewAgenda",
  },
  onlyHeader: {
    id: "onlyHeader",
    text: "Only Header",
    path: "page-layouts/only-header",
    icon: "ViewStream",
  },
  onlySubheader: {
    id: "onlySubheader",
    text: "Only Subheader",
    path: "page-layouts/only-subheader",
    icon: "ViewStream",
  },
  onlyContent: {
    id: "onlyContent",
    text: "Only Content",
    path: "page-layouts/only-content",
    icon: "WebAsset",
  },
};

export default primaryChemistMenu;
